<template lang="pug">
  div
    divider(label="Dados do ofício")
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nº do ofício:", :required="true")
          el-input.input.w-98(
            :disabled="true"
            v-model="despacho.tituloDespacho.oficioCcrDTO.numeroOficio"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Data de emissão do Ofício:", :required="true")
          el-input.input.w-98(
            :disabled="true"
            v-model="dataEmissaoHoje"
          )
          span.help.erro {{ errors[0] }}
    divider(label="Dados do processo")
    el-row(type='flex')
      el-col(:span="12").container-input
        app-label(label="Número do Processo:", :required="true")
        el-input.input.w-98(
          :disabled="true"
          v-model="despacho.processo.numeroProcesso"
        )
      el-col(:span="12").container-input
        app-label(label="Nome/Razão Social do Interessado:", :required="true")
        el-input.input.w-98(
          v-model="despacho.tituloDespacho.oficioCcrDTO.nomeRazaoSocialInteressado"
        )
      el-col(:span="12").container-input
        app-label(label="CPF/CNPJ do Interessado:", :required="true")
        el-input.input(
          :disabled="true"
          v-model="despacho.processo.cpfCnpjInteressado"
        )
    divider(label="Dados do Imóvel")
    el-row(:gutter="15").mt-10
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Denominação do Imóvel:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.denominacaoImovel"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Área do Imóvel:", :required="true")
          app-double-input.appInput(
            :hasValidationError="errors.length > 0",
            name='Área do Imóvel',
            :precision="4",
            :onkeypress="onlyInputNumbers",
            v-model="despacho.tituloDespacho.oficioCcrDTO.areaImovel",
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Título Dominial:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.tituloDominial"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Livro da Matrícula:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.livroMatricula"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Número da Matrícula:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.numeroMatricula"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Folha da Matrícula:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.folhaMatricula"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Data do Registro:", :required="true")
          el-date-picker.input.full-width(
            type="date",
            name='Data do Registro'
            v-model="despacho.tituloDespacho.oficioCcrDTO.dataRegistro",
            v-mask="'##/##/#####'",
            placeholder="Selecione",
            format="dd/MM/yyyy",
            :picker-options="pickerOptions",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nome da Gleba:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.nomeDaGleba"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Município do Imóvel:", :required="true")
          el-select.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.municipioImovel",
            class="select",
            placeholder="Selecione",
            value-key="id"
            filterable,
            clearable
          )
            el-option(
              v-for="mun in municipios",
              :key="mun.id",
              :label="mun.nome",
              :value="mun.nome"
          )
          span.help.erro {{ errors[0] }}
    divider(label="Dados do cartório")
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nome do cartório:", :required="true")
          el-input.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.nomeCartorio"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nome do Tabelião:", :required="true")
          el-input.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.nomeTabeliao"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        app-label(label="Estado:", :required="true")
        el-input.input(
          value="Maranhão"
          :disabled="true"
          v-model="despacho.tituloDespacho.oficioCcrDTO.uf"
        )
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Município:", :required="true")
          el-select.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.municipio",
            class="select",
            placeholder="Selecione",
            value-key="id"
            filterable,
            clearable
          )
            el-option(
              v-for="mun in municipios",
              :key="mun.id",
              :label="mun.nome",
              :value="mun.nome"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="CEP:", :required="true")
          el-input.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.cep",
            v-mask="['#####-###']"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Bairro:", :required="true")
          el-input.input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.bairro"
          )
          span.help.erro {{ errors[0] }}
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Número:", :required="true")
          el-input.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.numero",
            :disabled="despacho.tituloDespacho.oficioCcrDTO.semNumero",
            maxlength="10"
            :showAppend ="true",
          )
            el-checkbox.input(
              v-model="despacho.tituloDespacho.oficioCcrDTO.semNumero",
              label="S/N", slot="prepend",
              @change="onSemNumeroCheck"
            )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Rua:", :required="true")
          el-input.input.w-98(
            v-model="despacho.tituloDespacho.oficioCcrDTO.rua"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        app-label(label="Complemento:", :required="false")
        el-input.input(
          v-model="despacho.tituloDespacho.oficioCcrDTO.complemento"
        )
    el-row(type='flex')
      el-col(:span="8").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Órgão Adquirido:", :required="true")
          el-input(
            v-model="despacho.tituloDespacho.oficioCcrDTO.orgaoAdquirido"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="16").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Pronome de tratamento a ser utilizado no ofício:", :required="true")
          <el-radio-group v-model="despacho.tituloDespacho.oficioCcrDTO.pronome">
            <el-radio label="Senhora">Senhora</el-radio>
            <el-radio label="Senhor">Senhor</el-radio>
          </el-radio-group>
          span.help.erro {{ errors[0] }}
</template>

<script>
import Divider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import DadosOficio from '@/screens/analise/components/AppDadosOficio'
import DadosCartorio from '@/screens/analise/components/AppDadosCartorio'
import DadosProcesso from '@/screens/analise/components/AppDadosProcesso'
import AppDoubleInput from '@/components/AppDoubleInput'
import { mapActions } from 'vuex'
import Utils from '@/utils/utils'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppOpcoesHeaderAnalise from '../components/modal/AppOpcoesHeaderAnalise.vue'

export default {
  mixins: [onlyInputNumbers],
  components: {
    Divider,
    AppLabel,
    DadosOficio,
    DadosCartorio,
    DadosProcesso,
    AppDoubleInput,
    AppOpcoesHeaderAnalise
  },
  data () {
    return {
      cartorios: [],
      processo: {},
      municipios: {},
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  mounted () {
    if (this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro.includes('T')) {
      this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro = this.convertToDate(this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro.split('T')[0].split('-').reverse().join('/'))
    }
    if (this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro.includes(' ')) {
      this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro = this.convertToDate(this.despacho.tituloDespacho.oficioCcrDTO.dataRegistro.split(' ')[0])
    }
  },
  computed: {
    dataEmissaoHoje () {
      let hoje = new Date()
      const dd = String(hoje.getDate()).padStart(2, '0')
      const mm = String(hoje.getMonth() + 1).padStart(2, '0')
      const yyyy = hoje.getFullYear()

      hoje = dd + '/' + mm + '/' + yyyy
      return hoje
    },
    cepFormatado () {
      if (this.oficio.cartorio.endereco) {
        return this.formatCEP(this.oficio.cartorio.endereco.cep)
      } else {
        return ''
      }
    },
    complementoFormatado () {
      if (this.oficio.cartorio.nome) {
        return this.oficio.cartorio.endereco.complemento || '-'
      } else {
        return ''
      }
    },

    oficio () {
      return this.despacho.tituloDespacho.oficioCcrDTO
    }
  },
  methods: {
    ...mapActions({
      findCartoriosByProcesso: 'cartorioArrecadacao/findCartoriosByProcesso',
      findCartorioById: 'cartorioArrecadacao/findCartorioById',
      findProcessoById: 'processo/getProcessoById',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    formatCEP: Utils.formatCEP,
    format: Utils.format,
    convertToDate (str) {
      var parts = str.split('/')
      var day = parseInt(parts[0], 10)
      var month = parseInt(parts[1], 10) - 1
      var year = parseInt(parts[2], 10)

      return new Date(year, month, day)
    },
    onSemNumeroCheck (checked) {
      if (checked) {
        this.despacho.tituloDespacho.oficioCcrDTO.numero = 0
        return
      }

      this.despacho.tituloDespacho.oficioCcrDTO.numero = null
    }
  },
  async created () {
    this.municipios = await this.getMunicipiosByUf('MA')
    this.processo = await this.findProcessoById(this.$route.query.idProcesso)
  },
  props: {
    despacho: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.container-input {
  margin-right: 10px;
  margin-left: 10px;
}

.w-98 {
  width: 98%;
}

.el-select {
  display: block;
}

.mt-10 {
  margin-top: 10px;
}

.full-width {
  width: 100%;
}

.right {
  text-align: right;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/oficio/InformarDados.vue